import Base from "./base.service.js";
import Vue from "vue";
export default class User extends Base {
    constructor() {
        super("users");
    }
    checkAcc(email) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path + "check-user/" + email)
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
    resetPassword (email) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .post("/auth/reset-pwd", {
                    email: email
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => reject(err));
        });
    }
}
